import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedComprobantesAgregarValidosItemComponent {
  catalogos
  data
  mostrarDetalles = false
  onChange
  onDelete
  operadora

  actualizar (data) {
    this.mostrarDetalles = false
    this.data = Object.assign({}, data)
    this.onChange({$event: {detail: this.data}})
  }

  cancelar () {
    this.mostrarDetalles = false
  }
}

module.component('viaticosSharedComprobantesAgregarValidosItem', {
  controller: ViaticosSharedComprobantesAgregarValidosItemComponent,
  template,
  bindings: {
    catalogos: '<',
    data: '<',
    operadora: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/agregar/validos/item/component.js